var map = {
	"./events-bg.svg": 1462,
	"./events-logo.svg": 1463,
	"./home-active.svg": 1464,
	"./home.svg": 1465,
	"./livechat-active.svg": 1466,
	"./livechat.svg": 1467,
	"./me-active.svg": 1468,
	"./me.svg": 1469,
	"./promo-active.svg": 1470,
	"./promo.svg": 1471,
	"./sponsor-active.svg": 1472,
	"./sponsor.svg": 1473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1461;